import { jwtDecode } from 'jwt-decode'
import { jwtVerify, createRemoteJWKSet } from 'jose'

export async function isTokenValid(token: string) {
  try {
    const decoded = jwtDecode(token)
    const currentTime = Math.floor(Date.now() / 1000)

    if (decoded?.exp && decoded?.exp < currentTime) {
      return false
    }

    const jwksUri = (process.env.REACT_APP_JWKS_URI ?? '').trim()
    const JWKS = createRemoteJWKSet(new URL(jwksUri))
    await jwtVerify(token, JWKS, {
      algorithms: ['RS256']
    })

    return true
  } catch (error) {
    console.error('Error al validar el token:', error)
    return false
  }
}
